import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NavController } from "@ionic/angular";
import { MatInput } from "@angular/material/input";
import { AppService } from "src/app/services/app.service";
import { ApiserviceService } from "src/app/httpservice/apiservice.service";
import { STORAGE } from "src/app/constant/storages";
import { _getStorage } from "src/app/utils/local-storage";

@Component({
  selector: "app-resend-detail",
  templateUrl: "./resend-detail.component.html",
  styleUrls: ["./resend-detail.component.scss"],
})
export class ResendDetailComponent implements OnInit {
  @ViewChild("branchName") nameInput: MatInput;
  formResendDetail: FormGroup;
  radioOffice: string;
  fieldBranch: boolean;
  items: any;
  reportId: string;
  resendData: any;
  loading: boolean = true;

  tax_invoice_no: string = "";
  
  branch: string = "";
  branchType: string = "";
  buyer_type: string = "";
  notaxid = false;
  showbranch = false;
  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";
  mtransId: string = "";

  formData:any;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private builder: FormBuilder,
    private navController: NavController,
    private apiservice: ApiserviceService
  ) {
    this.userID = _getStorage(STORAGE.userID)
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.initialCreateFomrReportDetail();
    this.route.queryParams.subscribe(async (params) => {
      console.log('params : ' , params);
      if (Object.keys(params).length !== 0) {
        const { reportId, items } = params;
        this.items = JSON.parse(items);
        this.formData = params.formData
        console.log('this.formData======: ',this.formData )
        console.log('items======: ',this.items )
        this.tax_invoice_no = params.tax_invoice_no;
        this.mtransId = params.mtrans_id;
        await this.getData();
      }
    });
  }

  ngOnInit() {
    if (this.radioOffice === "branch") {
      this.fieldBranch = true;
    } else {
      this.fieldBranch = false;
    }
    this.loading = true;
  }
 
  initialCreateFomrReportDetail() {
    this.formResendDetail = this.builder.group({
      category: [{ value: "", disabled: true }],
      name: [{ value: "", disabled: true }],
      numberID: [{ value: "", disabled: true }],
      branchOrder: [{ value: "", disabled: true }],
    });
  }
  setFomrReportDetail(detail) {
    this.formResendDetail.patchValue({
      category: detail.category,
      name: detail.name,
      numberID: detail.numberID,
      branchOrder: detail.branchOrder,
    });
  }
  officeSetting(e) {
    if (e.detail.value === "branch") {
      this.fieldBranch = true;
      setTimeout(() => {
        this.nameInput.focus();
      }, 100);
    } else {
      this.fieldBranch = false;
    }
  }

  onBlackPage() {
    const navigationExtras = {
      queryParams: {
        formResend: this.formData,
      },
    };
    this.router.navigate(["resend-select-taxinvoice"],navigationExtras);

  }

  async getData() {
    this.loading = true;
    this.resendData = null;
    const url = `${this.apiservice.apiUrl}${this.apiservice.getTaxInvoiceDetail}`;

    const req = {
      taxinvoice_no: this.tax_invoice_no,
      userBu: this.items.bu,
      userLoc: this.items.loc,
      userRole: this.userRole,
      userSource: this.userSource,
      user_id: this.userID,
      mtrans_id: this.mtransId
    }
    console.log("req", req);

    const res = await this.apiservice._post(url, req);
    this.loading = false;
    console.log("res...", res);
    if (res.result === "S") {
      this.resendData = res.data[0];
      if(this.resendData.buyer.name_info.type === "3"){
        this.notaxid = false
      }else{
        this.notaxid = true
        this.buyer_type = this.resendData.buyer.name_info.type
      }

      if(this.resendData.buyer.name_info.type === "1"){
        this.showbranch = true
        this.branchType = res.data[0].branch_no == "" || res.data[0].branch_no == "00000"? '0':'1';
        this.branch = res.data[0].branch_no == "" || res.data[0].branch_no == "00000"?'':res.data[0].branch_no ;
      }else{
        this.showbranch = false
      }

    }
  }

  formatnumber(data) {
    return data.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
  number(data: any) {
    let number = data;
    return String(number).padStart(13, '0')
  }
}
